<!-- 专家服务 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-20">
        <infoContent title="专家信息" :showTitle="false" :info="infoContent" :showMore="false" :infoBlock="infoBlock1" count="1"/>
      </div>
      <div class="content-col col-per-50">
        <infoContent title="个人简介" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock2" :info="infoContent1" count="1"/>
        <infoContent title="其他信息" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock2" :info="infoContent2" count="1"/>
      </div>
      <div class="content-col col-per-20">
        <infoList title="服务流程" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage2" count="1"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoContent from '../block/InfoContent'
import InfoList from '../block/InfoList'
import ZjInfo2 from '../module/ZjInfo2'
import ZjInfo3 from '../module/ZjInfo3'
import FwlcInfo1 from '../module/FwlcInfo1'

export default {
  name: 'Jrfw03DetailA',
  components: {
    'infoContent':InfoContent,
    'infoList':InfoList,
  },
  data() {
    return {
      msg: '',
      infoBlock1:ZjInfo2,
      infoBlock2:ZjInfo3,
      infoBlock3:FwlcInfo1,
      infoContent:{},
      infoContent1:{label:''},
      infoContent2:{label:''},
      infoPage2:{list:[{1:1}],total:1},
    }
  },
  methods:{
    //专家详情
    zjxq_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.expertDetail(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;

          that.infoContent=res.data;
          that.infoContent1.label=res.data.introduction;
          that.infoContent2.label=res.data.organization;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  },
  created:function(){
    let that=this;
    let detailId=this.$route.params.id;
    let params={id:detailId};
    that.zjxq_Req(params);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-20 {
  flex-grow:1;
}

.col-per-50 {
  flex-grow:3;
}

.col-per-20 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Jrfw03DetailA.vue